import { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import useStores from 'useStores'
import CaseReviewTimer from '../CaseReviewTimer/CaseReviewTimer'

const ONE_SECOND_MS = 1000
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS
const ONE_HOUR_MS = 60 * ONE_MINUTE_MS

const getReviewStartTimeInSeconds = (
  recommendationReviewedAt?: string | null
): number => {
  const now = moment(new Date())
  const startTime =
    !recommendationReviewedAt || recommendationReviewedAt === '0'
      ? now
      : moment(recommendationReviewedAt)

  return Math.round(moment.duration(now.diff(startTime)).asSeconds())
}

const RecommendationReviewTimer: FC = observer(() => {
  const { caseReportStore } = useStores()
  const recommendationReviewedAt =
    caseReportStore.case?.recommendationReviewedAt

  const [caseTimer, setCaseTimer] = useState(() =>
    getReviewStartTimeInSeconds(recommendationReviewedAt)
  )

  useEffect(() => {
    setCaseTimer(getReviewStartTimeInSeconds(recommendationReviewedAt))

    const elapsedMs =
      getReviewStartTimeInSeconds(recommendationReviewedAt) * ONE_SECOND_MS
    const caseTimerInterval =
      elapsedMs >= ONE_HOUR_MS ? ONE_MINUTE_MS : ONE_SECOND_MS

    const interval = setInterval(() => {
      setCaseTimer(getReviewStartTimeInSeconds(recommendationReviewedAt))
    }, caseTimerInterval)

    return () => clearInterval(interval)
  }, [recommendationReviewedAt])

  return <CaseReviewTimer caseTimer={caseTimer} />
})

export default RecommendationReviewTimer
